import styled from '@emotion/styled'
import { css } from '@emotion/react'

// NOTE: remove on next ds release
const listContainerStyle = ({ theme }) => css`
  label: list_container;

  display: grid;
  gap: 5px;
  grid-template-columns: repeat(2, 50%);

  ${theme.media.kilo} {
    gap: ${theme.spacings.byte};
    grid-template-columns: repeat(3, 1fr);
  }

  ${theme.media.giga} {
    gap: ${theme.spacings.byte};
    grid-template-columns: repeat(4, 1fr);
  }
`

export const ListContainer = styled('ul')(listContainerStyle)

const listItemStyle = () => css`
  label: list_item;

  & > div {
    width: 100%;
  }
`

export const ListItem = styled('li')(listItemStyle)
